import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls, apiHostUrl, unauth } from '../../shared/utils/globalConfig';
import { addHeaders } from '../../shared/utils/globalUtils';

export const landingPageApi = createApi({
    reducerPath: 'landingPage',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        prepareHeaders: (headers) => {
            return addHeaders(headers, unauth);
        }
    }),
   
    endpoints: (builder) => ({
        getLandingByName: builder.query({
            query: () => ({
                url:  apiUrls?.landingPageUrl,
                method: 'Get'
            })
        }),
    }),

})

export const { useGetLandingByNameQuery } = landingPageApi;